import { motion } from 'framer-motion';

interface TrustSectionProps {
  onStartTest: () => void;
}

export default function TrustSection({ onStartTest }: TrustSectionProps) {
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 border-t border-[#e4e1d8]">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-11 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif font-medium text-3xl sm:text-4xl text-[#1d1f24]">
              Twelve years, a thousand rooms
            </h2>
            <blockquote className="mt-6 font-serif italic text-xl sm:text-2xl leading-relaxed text-[#1d1f24] border-l-2 border-[#c43b3b] pl-5">
              &ldquo;I have given this test at parties, at fairs, and at my own kitchen table. I have seen people laugh,
              go quiet, and occasionally tear up. Not because the cube is magic. Because being seen is rare.&rdquo;
            </blockquote>
            <p className="mt-3.5 text-sm text-[#5d606a]">Bram van der Boom, psychiatrist</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="space-y-3.5"
          >
            <p className="text-[#5d606a]">
              The cube test will not diagnose you. It is not science in a lab coat, and this site will not pretend it
              is. <b className="text-[#1d1f24] font-semibold">It is an invitation to say out loud how you see your world</b>,
              guided by someone who has listened to a thousand answers.
            </p>
            <p className="text-[#5d606a]">
              No invented user counts. No five star widgets. One psychiatrist, one white room, and whatever your
              imagination brings into it.
            </p>
            <p className="text-[#5d606a]">
              Your answers are encrypted and never shared. Your imagination stays yours alone.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="text-center mt-16"
        >
          <h3 className="font-serif font-medium text-3xl sm:text-4xl text-[#1d1f24]">Your room is already waiting.</h3>
          <p className="text-[#5d606a] mt-3 mb-6">Five minutes. Just your voice and your imagination.</p>
          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            onClick={onStartTest}
            className="inline-flex items-center gap-3 bg-[#c43b3b] text-white font-bold py-3.5 px-8 rounded-full text-lg shadow-[0_6px_18px_rgba(196,59,59,0.3)] hover:bg-[#b03434] transition-colors duration-200"
          >
            Take the Test, Free
          </motion.button>
          <p className="text-sm text-[#8a8d96] mt-4">No credit card required &middot; 5-minute conversation</p>
        </motion.div>
      </div>
    </section>
  );
}
